import { Chip, withStyles } from '@material-ui/core'
import {
  blue,
  blueB,
  darkBlue,
  gray,
  negativeB,
  negativeC,
  orange,
  orangeB,
  positiveB,
  positiveC,
  primaryB,
  primaryB2,
  primaryC,
  primaryStatus,
  purple,
  purpleB,
  secondaryB,
  yellow,
  yellowB,
  yellowStatus
} from 'lib/constants/colors'
import PropTypes from 'prop-types'
import React from 'react'

const styledBy = (property, mapping) => props => mapping[props[property]]

const styles = {
  root: {
    background: styledBy('color', {
      classic: secondaryB,
      blue: blueB + '!important',
      green: positiveC,
      red: negativeC,
      yellow: yellowB + '!important',
      black: '#2E2E2E',
      redOut: negativeB,
      blueOut: secondaryB,
      greenOut: positiveB,
      yellowOut: yellowB,
      greyOut: gray,
      orangeOut: orangeB,
      purpleOut: purpleB,
      purple,
      gray,
      orange,
      redDash: 'repeating-linear-gradient(-60deg, #FF4848 0, #FF4848 1px, transparent 1px, transparent 5px)',
      blueDash: 'repeating-linear-gradient(-60deg, #0B6EC7 0, #0B6EC7 1px, transparent 1px, transparent 5px)',
      purpleGreen: positiveC,
      primary: primaryB2,
      primaryStatus,
      yellowStatus,
      transparent: 'rgba(0,0,0,0)'
    }),
    color: styledBy('color', {
      classic: darkBlue,
      blue: blue + '!important',
      green: primaryC,
      red: primaryC,
      yellow: yellow + '!important',
      black: primaryC,
      redOut: negativeC,
      blueOut: primaryB,
      greenOut: positiveC,
      orangeOut: '#000',
      yellowOut: yellow,
      greyOut: '#2E2E2E',
      purple: primaryC,
      purpleOut: darkBlue,
      gray: darkBlue,
      orange: '#000',
      redDash: darkBlue,
      blueDash: darkBlue,
      purpleGreen: primaryC,
      primary: primaryB,
      primaryStatus: primaryC,
      yellowStatus: '#2E2E2E',
      transparent: 'rgba(0,0,0,0)'
    }),
    fontWeight: 600,
    fontSize: 12,
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 6,
    paddingBottom: 6,
    height: 28,
    borderRadius: 24,
    border: styledBy('color', {
      redOut: '1px solid ' + negativeC,
      blueOut: '1px solid ' + primaryB,
      greenOut: '1px solid ' + positiveC,
      yellowOut: '1px solid ' + yellow,
      greyOut: '1px solid #2E2E2E',
      orangeOut: '1px solid ' + orange,
      purpleOut: '1px solid ' + purple,
      blue: 'none',
      green: 'none',
      red: 'none',
      yellow: 'none',
      black: 'none',
      purple: 'none',
      gray: 'none',
      redDash: '1px solid ' + negativeC,
      blueDash: '1px solid ' + primaryB,
      purpleGreen: '5px solid ' + purple
    }),
    '&:focus': {
      backgroundColor: styledBy('color', {
        classic: secondaryB,
        blue: blueB,
        green: positiveC,
        red: negativeC,
        yellow,
        orange,
        black: '#2E2E2E',
        redOut: negativeB,
        blueOut: secondaryB,
        greenOut: positiveB,
        yellowOut: yellowB,
        yellowStatus,
        orangeOut: orangeB,
        purpleOut: purpleB,
        greyOut: gray,
        purple,
        gray,
        redDash: 'repeating-linear-gradient(-60deg, #FF4848 0, #FF4848 1px, transparent 1px, transparent 5px)',
        blueDash: 'repeating-linear-gradient(-60deg, #0B6EC7 0, #0B6EC7 1px, transparent 1px, transparent 5px)',
        purpleGreen: positiveC
      })
    },
    '&:hover': {
      filter: styledBy('color', {
        classic: 'brightness(100%)',
        blue: 'brightness(100%)',
        green: 'brightness(100%)',
        red: 'brightness(100%)',
        yellow: 'brightness(100%)',
        black: 'brightness(100%)',
        orange: 'brightness(100%)',
        redOut: 'none',
        blueOut: 'none',
        greenOut: 'none',
        yellowOut: 'none',
        greyOut: 'none',
        orangeOut: 'none',
        purpleOut: 'none',
        purple: 'brightness(100%)',
        gray: 'brightness(100%)',
        redDash: 'none',
        blueDash: 'none',
        purpleGreen: 'brightness(100%)'
      }),
      backgroundColor: styledBy('color', {
        classic: secondaryB,
        blue: blueB,
        green: positiveC,
        red: negativeC,
        orange,
        black: '#2E2E2E',
        redOut: negativeB,
        blueOut: secondaryB,
        greenOut: positiveB,
        yellowStatus,
        yellowOut: yellowB,
        orangeOut: orangeB,
        purpleOut: purpleB,
        greyOut: gray,
        purple,
        gray,
        redDash: 'repeating-linear-gradient(-60deg, #FF4848 0, #FF4848 1px, transparent 1px, transparent 5px)',
        blueDash: 'repeating-linear-gradient(-60deg, #0B6EC7 0, #0B6EC7 1px, transparent 1px, transparent 5px)',
        purpleGreen: positiveC
      }),
      color: styledBy('color', {
        classic: darkBlue,
        blue: blueB,
        green: primaryC,
        red: primaryC,
        yellow: '#2E2E2E',
        black: primaryC,
        redOut: negativeC,
        blueOut: primaryB,
        greenOut: positiveC,
        yellowOut: yellow,
        orange: '#000',
        orangeOut: '#000',
        greyOut: '#2E2E2E',
        purple: primaryC,
        purpleOut: darkBlue,
        yellowStatus: '#2E2E2E',
        gray: darkBlue,
        redDash: darkBlue,
        blueDash: darkBlue,
        purpleGreen: primaryC
      })
    }
  }
}

const AsterChip = withStyles(styles)(({ classes, color, ...other }) => <Chip className={classes.root} {...other} />)

export default AsterChip

AsterChip.propTypes = {
  color: PropTypes.oneOf([
    'classic',
    'blue',
    'green',
    'red',
    'yellow',
    'black',
    'purple',
    'orange',
    'gray',
    'redOut',
    'blueOut',
    'greenOut',
    'yellowOut',
    'orangeOut',
    'purpleOut',
    'greyOut',
    'blueDash',
    'redDash',
    'purpleGreen',
    'primaryStatus',
    'yellowStatus',
    'primary',
    'transparent'
  ]),
  label: PropTypes.string
}
